import script from "./TablaClasificacionLiga.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaClasificacionLiga.vue?vue&type=script&setup=true&lang=ts"

import "./TablaClasificacionLiga.vue?vue&type=style&index=0&id=a0a9e096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0a9e096"]])

export default __exports__